var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h4', {
    staticClass: "edit-heading mt-3"
  }, [_vm._v(_vm._s(_vm.$t("editProfile")))])])], 1), _c('v-card', {
    staticClass: "mb-4"
  }, [_c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "profile-img-upload"
  }, [_c('div', {
    staticClass: "preview-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.uploadedImageUrl ? _vm.uploadedImageUrl : '/img/profile.png',
      "alt": "Profile Image"
    }
  })]), _c('input', {
    ref: "fileUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.imageSelection
    }
  })])])], 1), _c('v-row', [_c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "mr-2 edit-btn set-img",
    on: {
      "click": function ($event) {
        return _vm.$refs.fileUpload.click();
      }
    }
  }, [_c('img', {
    staticClass: "upload-icon",
    attrs: {
      "src": "/img/edit.png",
      "alt": ""
    }
  }), _c('p', [_vm._v(_vm._s(_vm.$t("change")))])]), _vm.uploadedImageUrl ? _c('v-btn', {
    staticClass: "ml-2 delete-btn set-img",
    on: {
      "click": _vm.removeProfileImage
    }
  }, [_c('img', {
    staticClass: "upload-icon",
    attrs: {
      "src": "/img/delete.png",
      "alt": ""
    }
  }), _c('p', [_vm._v(_vm._s(_vm.$t("remove")))])]) : _vm._e()], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('firstName')
    },
    model: {
      value: _vm.first,
      callback: function ($$v) {
        _vm.first = $$v;
      },
      expression: "first"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('lastName')
    },
    model: {
      value: _vm.last,
      callback: function ($$v) {
        _vm.last = $$v;
      },
      expression: "last"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('email')
    },
    model: {
      value: _vm.email,
      callback: function ($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('phone')
    },
    model: {
      value: _vm.phone,
      callback: function ($$v) {
        _vm.phone = $$v;
      },
      expression: "phone"
    }
  })], 1)], 1), _c('v-row', _vm._l(_vm.customerInfo, function (field, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": 12,
        "md": 6,
        "order": index % 2
      }
    }, [field.fieldName !== 'Enable' ? _c('v-text-field', {
      attrs: {
        "type": field.dataType,
        "label": field.fieldName
      },
      model: {
        value: field.value,
        callback: function ($$v) {
          _vm.$set(field, "value", $$v);
        },
        expression: "field.value"
      }
    }) : _c('toggle-button', {
      staticClass: "toggoleProfile",
      attrs: {
        "value": true,
        "labels": {
          checked: 'Enable',
          unchecked: 'Disable'
        }
      },
      model: {
        value: field.value,
        callback: function ($$v) {
          _vm.$set(field, "value", $$v);
        },
        expression: "field.value"
      }
    })], 1);
  }), 1), _c('v-row', [_c('v-col', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary mr-3 pr-3 pl-3",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/profile');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("viewAddress.cancel")) + " ")]), _c('button', {
    staticClass: "btn btn-primary editSaveBtn ml-3 pr-4 pl-4",
    on: {
      "click": _vm.updateProfile
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("viewAddress.save")) + " ")])])], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }